import { type App, defineAsyncComponent } from 'vue';
const components = [
  {
    name: 'BevaSyncPopup',
    component: defineAsyncComponent(() => import('./BevaSyncPopup/BevaSyncPopup.vue')),
  },
  {
    name: 'BevaButton',
    component: defineAsyncComponent(() => import('./BevaButton/BevaButton.vue')),
  },
  {
    name: 'BevaActionButton',
    component: defineAsyncComponent(() => import('./BevaActionButton/BevaActionButton.vue')),
  },
  {
    name: 'BevaTable',
    component: defineAsyncComponent(() => import('./BevaTable/BevaTable.vue')),
  },
  {
    name: 'BevaSearchInput',
    component: defineAsyncComponent(() => import('./BevaSearchInput/BevaSearchInput.vue')),
  },
  {
    name: 'BevaBackwardHeader',
    component: defineAsyncComponent(() => import('./BevaBackwardHeader/BevaBackwardHeader.vue')),
  },
  {
    name: 'BevaSelect',
    component: defineAsyncComponent(() => import('./BevaSelect/BevaSelect.vue')),
  },
  {
    name: 'BevaLoading',
    component: defineAsyncComponent(() => import('./BevaLoading/BevaLoading.vue')),
  },
  {
    name: 'BevaRadio',
    component: defineAsyncComponent(() => import('./BevaRadio/BevaRadio.vue')),
  },
];

export default {
  install: (app: App) => {
    components.forEach((component) => {
      app.component(component.name, component.component);
    });
  },
};
